import {
  Box,
  Button,
  Divider,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import { useState } from "react";
import { Calculate } from "@mui/icons-material";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");

const ProctorCompactionDetails = ({
  isNonMobile,
  chartData,
  calculationOfChart,
  setChartData,
  calculationOfChartFinalVal,
}) => {
  const [errorCheck, setErrorCheck] = useState({
    serialNo: {
      error: false,
    },
    dateOfCast: {
      error: false,
    },
    dateOfTest: {
      error: false,
    },
    weight: {
      error: false,
    },
    concreteMixture: {
      error: false,
    },
    areaOfCube: {
      error: false,
    },
    compressiveStrength: {
      error: false,
    },
  });

  return (
    <Box justifyItems="center">
      <Paper variant="elevation" elevation={2} sx={{ padding: "10px" }}>
        <Box
          display="grid"
          gap={0.5}
          alignItems="center"
          gridTemplateColumns="repeat(6, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 6",
            },
          }}
        >
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            variant="h5"
            textAlign="center"
          >
            TEST
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h5"
          >
            1
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h5"
          >
            2
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h5"
          >
            3
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h5"
          >
            4
          </Typography>
          <Typography
            sx={{ gridColumn: "span 1" }}
            color="info"
            textAlign="center"
            variant="h5"
          >
            5
          </Typography>
          <Divider
            sx={{
              marginTop: "2px",
              marginBottom: "2px",
              gridColumn: "span 6",
            }}
          />
          <Typography
            sx={{
              gridColumn: "span 1",
              width: "100%",
            }}
            color="info"
            textAlign="left"
            variant="h6"
          >
            Water added
          </Typography>
          <TextField
            value={chartData.waterAdded1}
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                waterAdded1: e.target.value,
              }))
            }
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={chartData.waterAdded2}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                waterAdded2: e.target.value,
              }))
            }
          />
          <TextField
            value={chartData.waterAdded3}
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                waterAdded3: e.target.value,
              }))
            }
          />
          <TextField
            value={chartData.waterAdded4}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                waterAdded4: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.waterAdded5}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                waterAdded5: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Wt cylinder + Wet soild(g)
          </Typography>
          <TextField
            value={chartData.cylinderWetSoil1}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinderWetSoil1: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{
              gridColumn: "span 1",
            }}
            inputProps={{
              style: {
                textAlign: "center",
                fontSize: "14px",
              },
            }}
          />

          <TextField
            value={chartData.cylinderWetSoil2}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinderWetSoil2: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={chartData.cylinderWetSoil3}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinderWetSoil3: e.target.value,
              }))
            }
          />
          <TextField
            value={chartData.cylinderWetSoil4}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinderWetSoil4: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.cylinderWetSoil5}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinderWetSoil5: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Weight of cylinder (g)
          </Typography>
          <TextField
            value={chartData.cylinder1}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinder1: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.cylinder2}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinder2: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />

          <TextField
            value={chartData.cylinder3}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinder3: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={chartData.cylinder4}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinder4: e.target.value,
              }))
            }
          />
          <TextField
            value={chartData.cylinder5}
            onChange={(e) =>
              setChartData((pre) => ({
                ...pre,
                cylinder5: e.target.value,
              }))
            }
            size="small"
            variant="outlined"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Weight of soil (g)
          </Typography>
          <TextField
            value={chartData.wetSoil1}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.wetSoil2}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.wetSoil3}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />

          <TextField
            value={chartData.wetSoil4}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            fullWidth
            variant="outlined"
            type="number"
            disabled
            size="small"
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
            value={chartData.wetSoil5}
          />
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Bulk unit weight (g/cm²)
          </Typography>
          <TextField
            value={chartData.bulkWeight1}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.bulkWeight2}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.bulkWeight3}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <TextField
            value={chartData.bulkWeight4}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />

          <TextField
            value={chartData.bulkWeight5}
            size="small"
            variant="outlined"
            disabled
            sx={{ gridColumn: "span 1" }}
            inputProps={{
              style: { textAlign: "center", fontSize: "14px" },
            }}
          />
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Tin no
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinNo5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinNo5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Wt. of tin + Wet soil (g)
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinWetSoil5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinWetSoil5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Wt. of tin + Dry soil (g)
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tinDrySoil5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tinDrySoil5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Wt. of tin (g)
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.tin5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  tin5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Wt. of water (g)
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              size="small"
              disabled
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              variant="outlined"
              type="number"
              disabled
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.water5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  water5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Wt. of dry soil (g)
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.waterDrySoil5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  waterDrySoil5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            M.C. %
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.mc5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  mc5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Average M.C.
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.averageMc5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  averageMc5_2: e.target.value,
                }))
              }
            />
          </Box>
          <Typography sx={{ gridColumn: "span 1" }} color="info" variant="h6">
            Dry unit weight (g/cm²)
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight1_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight1_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight1_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight1_2: e.target.value,
                }))
              }
            />
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight2_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight2_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight2_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight2_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight3_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight3_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight3_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight3_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={1}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight4_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight4_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight4_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight4_2: e.target.value,
                }))
              }
            />
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            gap={0.5}
            sx={{ gridColumn: "span 1" }}
          >
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight5_1}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight5_1: e.target.value,
                }))
              }
            />
            <TextField
              fullWidth
              disabled
              variant="outlined"
              type="number"
              size="small"
              sx={{ gridColumn: "span 1" }}
              inputProps={{
                style: { textAlign: "center", fontSize: "14px" },
              }}
              value={chartData.dryUnitWeight5_2}
              onChange={(e) =>
                setChartData((pre) => ({
                  ...pre,
                  dryUnitWeight5_2: e.target.value,
                }))
              }
            />
          </Box>
        </Box>
        <Divider sx={{ marginTop: "10px" }} />
        <Button
          variant="contained"
          color="success"
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
          startIcon={<Calculate />}
          onClick={calculationOfChart}
        >
          Calculate
        </Button>

        <Button
          variant="contained"
          color="success"
          sx={{ gridColumn: "span 1", marginTop: "5px" }}
          startIcon={<Calculate />}
          onClick={calculationOfChartFinalVal}
        >
          Calculate Second
        </Button>
      </Paper>
    </Box>
  );
};

export default ProctorCompactionDetails;
